/* Нижняя панель (Figma Tabs_classic I1073:20355;13332:54987, HQ-1887): сплошная --surface с блюром 20 Figma = 10px CSS,
   без линии сверху; 60 = пункты 48 + отступ снизу 12, под ним — безопасная зона. Тёмная тема — те же числа токенами. */
.bar {
  position: fixed; left: 0; right: 0; bottom: 0; z-index: 10;
  display: flex; padding: 0 0 calc(var(--space-3) + var(--tg-safe-bottom));
  background: var(--surface); backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
  border-top: 0;
  transition: transform 0.25s ease;
}
.hidden { transform: translateY(100%); }
@media (prefers-reduced-motion: reduce) { .bar { transition: none; } }
.tab {
  flex: 1; min-width: 0; min-height: 48px; container-type: inline-size; display: flex; flex-direction: column; align-items: center;
  justify-content: center; gap: 2px; color: var(--content-secondary);
}
.selected { color: var(--content-primary); }
/* Иконка 24 × 24, подпись 11/600 межстрочие 13 (Caption 2/Emphasized) */
/* HQ-1112 v3: при крупном шрифте подпись не обрезается многоточием — кегль ужимается по ширине вкладки (16cqi: при 1×
   от 344 px экрана — прежние 11 px), но не меньше 10px; не влезло и так — перенос по словам до 2 строк, панель растёт */
.label {
  font-size: clamp(10px, 16cqi, var(--fs-caption2)); line-height: 1.182; font-weight: 600; max-width: 100%;
  text-align: center; overflow-wrap: break-word;
  display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;
}
/* Мир (data-scene на <html>: world — экраны мира, field — сцена): панель — тёмное стекло, сквозь неё видно поле;
   своя геометрия (пункты 50, отступ снизу 8 или безопасная зона, линия сверху) — без изменений HQ-1887 */
:global(:root[data-scene]) .bar {
  padding-bottom: max(var(--space-2), var(--tg-safe-bottom));
  background: rgba(8, 24, 12, 0.38); border-top: 0.5px solid rgba(255, 255, 255, 0.18);
  backdrop-filter: saturate(160%) blur(14px); -webkit-backdrop-filter: saturate(160%) blur(14px);
}
:global(:root[data-scene]) .tab { min-height: 50px; }
:global(:root[data-scene]) .label { line-height: 1.2; }
:global(:root[data-scene]) .tab { color: rgba(255, 255, 255, 0.78); }
:global(:root[data-scene]) .selected { color: #fff; }

/* §288: «Fantasy» — большая вкладка входа в игровой мир: золотой круг с калиткой-монстром приподнят над панелью */
.big { position: relative; }
.big :global(.tabArt) { display: grid; place-items: center; width: 52px; height: 52px; margin-top: -22px; border-radius: 50%;
  background: radial-gradient(circle at 35% 30%, #ffe89a, #f0b422 60%, #b9780c); border: 3px solid var(--surface);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.28), inset 0 2px 0 rgba(255, 255, 255, 0.5); }
.big :global(.tabArt) img { width: 40px; height: 40px; object-fit: contain; filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.35)); }
.big:active :global(.tabArt) { transform: scale(0.94); }
.big .label { color: var(--accent-ink); font-weight: 800; }
/* Режим поиска экрана (поиск «Избранного», HQ-1058, макет 1073:20924): нижней панели нет */
:global(:root[data-search-mode]) .bar { display: none; }
